import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import GeneralLayout from "../layout/GeneralLayout";
import { apiCall } from "../utills/APICall";
import styles from "../downloadPage.module.css";

export default function Download() {
  const location = useLocation();
  const navigate = useNavigate();
  const [downloadData, setDownloadData] = useState(null);
  const [polling, setPolling] = useState(true);

  const progressId = location.state?.progressId;

  useEffect(() => {
    if (!progressId) {
      navigate("/");
      return;
    }

    const interval = setInterval(async () => {
      try {
        const res = await apiCall(`download-progress/${progressId}`, "GET");
        const status = res?.data?.data?.status;
        if (status === "Completed") {
          setDownloadData(res.data.data);
          setPolling(false);
        }
      } catch (error) {
        console.error("Polling error:", error);
      }
    }, 3000);

    return () => clearInterval(interval);
  }, [progressId, navigate]);

  if (polling) {
    return (
      <div className={styles.loaderContainer} role="status" aria-live="polite">
        <div className={styles.loader}></div>
        <p className={styles.loaderText}>Fetching download status...</p>
      </div>
    );
  }

  return (
    <GeneralLayout>
      <div className={styles.container}>
        <h2 className={styles.resultsTitle}>Download Ready</h2>
        <div className={styles.card}>
          <p><strong>File Name:</strong> {downloadData.fileName}</p>
          <p><strong>Status:</strong> {downloadData.status}</p>
          <p><strong>Progress:</strong> {downloadData.progress}%</p>
          <p><strong>Inserted Count:</strong> {downloadData.insertedCount}</p>
          <p><strong>Estimated Time Remaining:</strong> {downloadData.estimatedTimeRemaining}s</p>
          <a
            href={downloadData.downloadLink}
            className={styles.downloadButton}
            download
          >
            Download File
          </a>
        </div>
      </div>
    </GeneralLayout>
  );
}
